(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the blockname-block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		var map;

		function initMap() {
			let icon =
				'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080"><g opacity="0.1"><path stroke-width="0" fill="#ff4500" d="M540,1079.5c-72.83,0-143.49-14.26-210-42.4-64.24-27.17-121.94-66.07-171.49-115.62-49.55-49.55-88.45-107.24-115.62-171.49C14.76,683.49.5,612.83.5,540s14.26-143.49,42.4-210c27.17-64.24,66.07-121.94,115.62-171.49,49.55-49.55,107.24-88.45,171.49-115.62C396.51,14.76,467.17.5,540,.5s143.49,14.26,210,42.4c64.24,27.17,121.94,66.07,171.49,115.62,49.55,49.55,88.45,107.24,115.62,171.49,28.13,66.51,42.4,137.17,42.4,210s-14.26,143.49-42.4,210c-27.17,64.24-66.07,121.94-115.62,171.49s-107.24,88.45-171.49,115.62c-66.51,28.13-137.17,42.4-210,42.4Z"/><path stroke-width="0" fill="#ff4500" d="M540,1c72.76,0,143.35,14.25,209.8,42.36,31.94,13.51,62.74,30.23,91.56,49.7,28.54,19.28,55.38,41.43,79.77,65.82,24.39,24.39,46.54,51.23,65.82,79.77,19.47,28.81,36.19,59.62,49.7,91.56,28.11,66.45,42.36,137.04,42.36,209.8s-14.25,143.35-42.36,209.8c-13.51,31.94-30.23,62.74-49.7,91.56-19.28,28.54-41.43,55.38-65.82,79.77-24.39,24.39-51.23,46.54-79.77,65.82-28.81,19.47-59.62,36.19-91.56,49.7-66.45,28.11-137.04,42.36-209.8,42.36s-143.35-14.25-209.8-42.36c-31.94-13.51-62.74-30.23-91.56-49.7-28.54-19.28-55.38-41.43-79.77-65.82-24.39-24.39-46.54-51.23-65.82-79.77-19.47-28.81-36.19-59.62-49.7-91.56C15.25,683.35,1,612.76,1,540s14.25-143.35,42.36-209.8c13.51-31.94,30.23-62.74,49.7-91.56,19.28-28.54,41.43-55.38,65.82-79.77,24.39-24.39,51.23-46.54,79.77-65.82,28.81-19.47,59.62-36.19,91.56-49.7C396.65,15.25,467.24,1,540,1M540,0C241.77,0,0,241.77,0,540s241.77,540,540,540,540-241.77,540-540S838.23,0,540,0h0Z"/></g><g><path fill="#fff" d="M540,977.5c-59.06,0-116.36-11.57-170.29-34.38-52.1-22.04-98.89-53.58-139.06-93.76-40.18-40.18-71.72-86.97-93.76-139.06-22.81-53.94-34.38-111.23-34.38-170.29s11.57-116.36,34.38-170.29c22.04-52.1,53.58-98.89,93.76-139.06,40.18-40.18,86.97-71.72,139.06-93.76,53.94-22.81,111.23-34.38,170.29-34.38s116.36,11.57,170.29,34.38c52.1,22.04,98.88,53.58,139.06,93.76,40.18,40.18,71.72,86.97,93.76,139.06,22.81,53.94,34.38,111.23,34.38,170.29s-11.57,116.36-34.38,170.29c-22.04,52.1-53.58,98.88-93.76,139.06-40.18,40.18-86.97,71.72-139.06,93.76-53.94,22.81-111.23,34.38-170.29,34.38Z"/><path fill="#fff" d="M540,103c59,0,116.22,11.55,170.1,34.34,52.04,22.01,98.77,53.52,138.91,93.65,40.13,40.13,71.64,86.87,93.65,138.91,22.79,53.88,34.34,111.1,34.34,170.1s-11.55,116.22-34.34,170.1c-22.01,52.04-53.52,98.77-93.65,138.91s-86.87,71.64-138.91,93.65c-53.88,22.79-111.1,34.34-170.1,34.34s-116.22-11.55-170.1-34.34c-52.04-22.01-98.77-53.52-138.91-93.65s-71.64-86.87-93.65-138.91c-22.79-53.87-34.34-111.1-34.34-170.1s11.55-116.22,34.34-170.1c22.01-52.04,53.52-98.77,93.65-138.91,40.13-40.13,86.87-71.64,138.91-93.65,53.87-22.79,111.1-34.34,170.1-34.34M540,102c-241.9,0-438,196.1-438,438s196.1,438,438,438,438-196.1,438-438S781.9,102,540,102h0Z"/></g><path id="Path_5051" data-name="Path 5051" stroke-width="0" fill="#ff4500" d="M691.97,626.12h129.76v-350.12h-129.76l-46.76,86.98h46.76v263.14Z"/><path id="Path_5052" data-name="Path 5052" stroke-width="0" fill="#ff4500" d="M687.18,655.12c-6.63,15.22-22.12,24.62-38.68,23.46-32.09,0-43.48-24.28-43.48-47v-268.62h-129.76v268.62c0,22.72-11.42,47-43.48,47s-43.48-24.28-43.48-47v-268.62h-129.75v266.51c-2.34,93.72,71.74,171.59,165.46,173.92,2.6.06,5.2.07,7.8.02,39.83.67,78.48-13.5,108.44-39.75,29.84,26.33,68.48,40.52,108.27,39.75,86.71,1.89,160.76-62.21,171.32-148.29h-132.66Z"/></svg>\n';
			let icons = {
				default: {
					icon: {
						url:
							'data:image/svg+xml;charset=UTF-8,' +
							encodeURIComponent(icon),
						anchor: new google.maps.Point(30, 163.992),
					},
				},
			};
			const __map = $block.find('#map');
			const latlng = {
				lat: parseFloat(__map.data('lat')),
				lng: parseFloat(__map.data('lng')),
			};
			// Move the map to the clicked location and add a pin
			map = new google.maps.Map($block.find('#map')[0], {
				styles: [
					{
						featureType: 'administrative',
						stylers: [
							{
								saturation: '-100',
							},
						],
					},
					{
						featureType: 'administrative.province',
						stylers: [
							{
								visibility: 'off',
							},
						],
					},
					{
						featureType: 'landscape',
						stylers: [
							{
								saturation: -100,
							},
							{
								lightness: 65,
							},
							{
								visibility: 'on',
							},
						],
					},
					{
						featureType: 'poi',
						stylers: [
							{
								saturation: -100,
							},
							{
								lightness: '50',
							},
							{
								visibility: 'simplified',
							},
						],
					},
					{
						featureType: 'road',
						stylers: [
							{
								saturation: '-100',
							},
						],
					},
					{
						featureType: 'road.arterial',
						stylers: [
							{
								lightness: '30',
							},
						],
					},
					{
						featureType: 'road.highway',
						stylers: [
							{
								visibility: 'simplified',
							},
						],
					},
					{
						featureType: 'road.local',
						stylers: [
							{
								lightness: '40',
							},
						],
					},
					{
						featureType: 'transit',
						stylers: [
							{
								saturation: -100,
							},
							{
								visibility: 'simplified',
							},
						],
					},
					{
						featureType: 'water',
						elementType: 'geometry',
						stylers: [
							{
								hue: '#ffff00',
							},
							{
								saturation: -97,
							},
							{
								lightness: -25,
							},
						],
					},
					{
						featureType: 'water',
						elementType: 'labels',
						stylers: [
							{
								saturation: -100,
							},
							{
								lightness: -25,
							},
						],
					},
				],
				zoom: 18, // Set your desired zoom level
			});

			const marker = new google.maps.Marker({
				position: {
					lat: parseFloat(__map.data('lat')),
					lng: parseFloat(__map.data('lng')),
				},

				icon: icons['default'].icon,
				map: map,
			});

			map.panTo(latlng);
		}

		// Initialize the map when the block is loaded
		initMap();
	};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.contact-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=contact-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
